var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWishlistBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2422_54969)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0472 20.3502L11.0465 20.3496C8.71984 18.0501 6.82668 16.1756 5.50939 14.4191C4.19855 12.6712 3.5 11.0933 3.5 9.3951C3.5 6.5994 5.49323 4.5 7.95 4.5C9.34814 4.5 10.7116 5.21231 11.6072 6.34966L12 6.84851L12.3928 6.34966C13.2884 5.21231 14.6519 4.5 16.05 4.5C18.5068 4.5 20.5 6.5994 20.5 9.3951C20.5 11.0933 19.8014 12.6712 18.4906 14.4191C17.1733 16.1756 15.2802 18.0501 12.9535 20.3496L12.9528 20.3502L12 21.2956L11.0472 20.3502Z",
    stroke: "#252525"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2422_54969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlistBlack);
export default __webpack_public_path__ + "static/media/wishlist-black.8515a1a7641da54d52b368f25d636454.svg";
export { ForwardRef as ReactComponent };